import _objectWithoutProperties from "/codebuild/output/src1506462530/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["component", "saveRegion"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { StateStatus } from '@guryou/redux';
// import moment from 'moment-timezone';

//eslint-disable-next-line
const PrivateRoute = _ref => {
  let {
      component: Component,
      saveRegion = false
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const el = new URLSearchParams(window.location.search).get('el');
  const pw = new URLSearchParams(window.location.search).get('pw');
  // const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);

  // useEffect(() => {
  //   if (saveRegion) {
  //     if (auth?.data && auth?.data.userId) {
  //       dispatch(saveUserRegion(moment.tz.guess()));
  //     }
  //   }
  //   //eslint-disable-next-line
  // }, [auth.version, saveRegion]);

  let url = '/login';
  if (el && pw) {
    url = "/login?el=".concat(decodeURIComponent(el), "&pw=").concat(decodeURIComponent(pw));
  }
  if (!auth || (auth === null || auth === void 0 ? void 0 : auth.data) === null || (auth === null || auth === void 0 ? void 0 : auth.staus) < StateStatus.LOADED || auth.data.exp * 1000 < +new Date()) {
    var _auth$data;
    if (auth !== null && auth !== void 0 && auth.data && (auth === null || auth === void 0 ? void 0 : (_auth$data = auth.data) === null || _auth$data === void 0 ? void 0 : _auth$data.user) === null) {
      return /*#__PURE__*/React.createElement(Redirect, {
        to: url
      });
    }
    return /*#__PURE__*/React.createElement(Redirect, {
      to: url
    });
  }
  return /*#__PURE__*/React.createElement(Route, _extends({}, rest, {
    render: props => /*#__PURE__*/React.createElement(Component, props)
  }));
};
export { PrivateRoute };